import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { TProduct } from 'modules/ProductManagement/reducers/type';
import { ProductTitleContainer } from '../../style';
import { getFirstElementInProductList } from '../../reducers/accessors';

const ProductTitle: React.FC = () => {
    const { productType, serialNumber } = useSelector<RootState, TProduct>(getFirstElementInProductList);
    const formattedSerialNumber = serialNumber.match(/.{1,4}/g)?.join(' ');
    return (
        <ProductTitleContainer>
            <h2 data-testid="productType">{productType}</h2>
            <p data-testid="serialNumber">Serial: {formattedSerialNumber}</p>
        </ProductTitleContainer>
    );
};

export default ProductTitle;
